import { DateTime, Duration } from 'luxon';

export const addDuration = (dt: DateTime, duration: Duration): DateTime => dt.plus(duration);

export const roundToNextHour = (extraHours?: number): DateTime => {
  const nextHour = DateTime.now().set({ minute: 0 }).plus({ hours: 1 });
  return extraHours ? nextHour.plus({ hours: extraHours }) : nextHour;
};
